import {UserRepository} from "~/api/v1/users/UserRepository";
import {MissionRepository} from "~/api/v1/missions/MissionRepository";
import {AuthRepository} from "~/api/v1/auth/AuthRepository";
import {BusinessProviderRepository} from "~/api/v1/business-provider/BusinessProviderRepository";
import {CompanyRepository} from "~/api/v1/companies/CompanyRepository";
import {InvoiceRepository} from "~/api/v1/invoices/InvoiceRepository";
import {InvitationRepository} from "~/api/v1/invitations/InvitationRepository";
import {MissionStatisticalRepository} from "~/api/v1/missions/MissionStatisticalRepository";
import {AdminRepository} from "~/api/v1/admin/AdminRepository";
import {CreditNoteRequestRepository} from "~/api/v1/credit-note-requests/CreditNoteRequestRepository";
import {LogoChangeRequestRepository} from "~/api/v1/logo-change-requests/LogoChangeRequestRepository";
import {JarodRepository} from "~/api/v1/jarod/JarodRepository";
import type {$Fetch} from "nitropack";

const repositories =  (client: $Fetch) => {
    return {
        users: UserRepository(client),
        auth: AuthRepository(client),
        company: CompanyRepository(client),
        missions: MissionRepository(client),
        missionsStatistical: MissionStatisticalRepository(client),
        businessProvider: BusinessProviderRepository(client),
        invoices: InvoiceRepository(client),
        invitations: InvitationRepository(client),
        admin: AdminRepository(client),
        creditNoteRequests: CreditNoteRequestRepository(client),
        logoChangeRequests: LogoChangeRequestRepository(client),
        jarod: JarodRepository(client),
    }
}

export default repositories;